import { render, staticRenderFns } from "./quantity-donut.app.vue?vue&type=template&id=a895046c&scoped=true&"
import script from "./quantity-donut.app.vue?vue&type=script&lang=js&"
export * from "./quantity-donut.app.vue?vue&type=script&lang=js&"
import style0 from "./quantity-donut.app.vue?vue&type=style&index=0&id=a895046c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a895046c",
  null
  
)

export default component.exports